import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import { selectFirstList } from "@/redux/modules/api/data/wishlist/wishlist.module";
import { getWishlists } from "@/redux/modules/api/data/wishlist/wishlist.selectors";
import { update } from "@/redux/modules/value/wishlistSidebar/wishlistSidebar.module";
import {
    getCurrentListId,
    isSidebarVisible
} from "@/redux/modules/value/wishlistSidebar/wishlistSidebar.selectors";
import BreakpointsService from "@/services/breakpoint.service";
import { stringToBoolean } from "@/utils/attributes";

import { WishlistSidebarComponent } from "./WishlistSidebar.component";

export type WishlistSidebarContainerProps = {
    isMobile: string;
};

const WishlistSidebarContainer = ({
    isMobile
}: WishlistSidebarContainerProps) => {
    const dispatch = useThunkDispatch();

    const wishlists = useSelector(getWishlists);
    const isVisible = useSelector(isSidebarVisible);
    const currentListId = useSelector(getCurrentListId);

    const isMobileMode = stringToBoolean(isMobile);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (
            wishlists.length > 0 &&
            (!currentListId || !wishlists.some((w) => w.id === currentListId))
        ) {
            dispatch(selectFirstList());
        }
    }, [currentListId, wishlists]);

    const onToggle = () => {
        dispatch(update({ visible: !isVisible }));
    };

    if (isMobileMode && BreakpointsService.matchesMinLg()) {
        return null;
    }

    return (
        <WishlistSidebarComponent
            wishlists={wishlists || []}
            isVisible={isVisible}
            onToggle={onToggle}
            isMobileMode={isMobileMode && !BreakpointsService.matchesMinLg()}
        />
    );
};

export { WishlistSidebarContainer };
